// Boss configurations
export interface BossConfig {
  type: string;
  name: string;
  hp: number;
  speed: number;
  score: number;
  size: number;
  color: string;
  phases: number;
  enrageThreshold: number; // HP percentage for enrage
}

export const BOSS_TYPES: Record<string, BossConfig> = {
  HUNGER_WORM_JR: {
    type: 'hunger_worm_jr',
    name: 'Hunger Worm Jr.',
    hp: 50,
    speed: 1.5,
    score: 500,
    size: 64,
    color: '#ff6600',
    phases: 2,
    enrageThreshold: 0.33,
  },
  GIANT_HUNGER_WORM: {
    type: 'giant_hunger_worm',
    name: 'Giant Hunger Worm',
    hp: 150,
    speed: 1,
    score: 1500,
    size: 96,
    color: '#ff3300',
    phases: 3,
    enrageThreshold: 0.33,
  },
  SHADOW_KING: {
    type: 'shadow_king',
    name: 'Shadow King',
    hp: 200,
    speed: 1.2,
    score: 1500,
    size: 96,
    color: '#333333',
    phases: 3,
    enrageThreshold: 0.33,
  },
  GREED_MACHINE: {
    type: 'greed_machine',
    name: 'Greed Machine',
    hp: 250,
    speed: 0.8,
    score: 1500,
    size: 96,
    color: '#00cc00',
    phases: 3,
    enrageThreshold: 0.33,
  },
  STORM_TITAN: {
    type: 'storm_titan',
    name: 'Storm Titan',
    hp: 300,
    speed: 1,
    score: 1500,
    size: 128,
    color: '#0088ff',
    phases: 3,
    enrageThreshold: 0.33,
  },
  CAPITOL_GUARDIAN: {
    type: 'capitol_guardian',
    name: 'Capitol Guardian',
    hp: 500,
    speed: 0.8,
    score: 3000,
    size: 128,
    color: '#ffffff',
    phases: 4,
    enrageThreshold: 0.25,
  },
};

// Boss attack patterns by phase
export interface BossPhase {
  attacks: string[];
  fireRate: number;
  movePattern: string;
}

export const BOSS_PHASES: Record<string, BossPhase[]> = {
  giant_hunger_worm: [
    {
      attacks: ['sweep'],
      fireRate: 1,
      movePattern: 'horizontal_sweep',
    },
    {
      attacks: ['spawn_minions'],
      fireRate: 1.5,
      movePattern: 'figure_eight',
    },
    {
      attacks: ['spread_shot'],
      fireRate: 2,
      movePattern: 'aggressive',
    },
  ],
  shadow_king: [
    {
      attacks: ['flicker'],
      fireRate: 1,
      movePattern: 'teleport',
    },
    {
      attacks: ['clone_summon'],
      fireRate: 1.2,
      movePattern: 'circle',
    },
    {
      attacks: ['darkness_wave'],
      fireRate: 2,
      movePattern: 'aggressive',
    },
  ],
  greed_machine: [
    {
      attacks: ['charge'],
      fireRate: 0.8,
      movePattern: 'charging',
    },
    {
      attacks: ['spawn_gremlins'],
      fireRate: 1.5,
      movePattern: 'stationary',
    },
    {
      attacks: ['vacuum_pull'],
      fireRate: 2,
      movePattern: 'pulling',
    },
  ],
  storm_titan: [
    {
      attacks: ['lightning_strike'],
      fireRate: 1,
      movePattern: 'floating',
    },
    {
      attacks: ['wind_push'],
      fireRate: 1.5,
      movePattern: 'aggressive',
    },
    {
      attacks: ['hurricane_bullets'],
      fireRate: 3,
      movePattern: 'spinning',
    },
  ],
  capitol_guardian: [
    {
      attacks: ['rotating_shield'],
      fireRate: 1,
      movePattern: 'stationary',
    },
    {
      attacks: ['beam_sweep'],
      fireRate: 1.5,
      movePattern: 'slow_horizontal',
    },
    {
      attacks: ['multi_attack'],
      fireRate: 2,
      movePattern: 'figure_eight',
    },
    {
      attacks: ['unity_burst'],
      fireRate: 3,
      movePattern: 'aggressive',
    },
  ],
};
